import { window } from './globals';

export const FEATURE_TOGGLE_LOCAL_OVERRIDES_STORAGE_KEY =
  '@@lifeomic/phc-ui/featureToggleOverrides';

export function readStoredFeatureToggleOverrides(): Record<string, boolean> {
  try {
    const raw = window?.localStorage?.getItem(
      FEATURE_TOGGLE_LOCAL_OVERRIDES_STORAGE_KEY,
    );
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (
      !parsed ||
      typeof parsed !== 'object' ||
      Array.isArray(parsed) ||
      parsed === null
    ) {
      return {};
    }
    return parsed as Record<string, boolean>;
  } catch {
    return {};
  }
}

export function writeStoredFeatureToggleOverrides(
  overrides: Record<string, boolean>,
): void {
  try {
    window?.localStorage?.setItem(
      FEATURE_TOGGLE_LOCAL_OVERRIDES_STORAGE_KEY,
      JSON.stringify(overrides),
    );
  } catch {
    // QuotaExceeded, private mode, or disabled storage
  }
}

export function setStoredFeatureToggleOverride(
  feature: string,
  value: boolean,
): void {
  const next = { ...readStoredFeatureToggleOverrides(), [feature]: value };
  writeStoredFeatureToggleOverrides(next);
}
